import React, {useState} from "react";
import HeaderComponent from "../../components/HeaderComponent";
import "./../../utils/Style/pages/Statementofaccounts.scss";
import SoaTemplate from "./SoaTemplate";
import MerchantSoaTemplate from "./MerchantSoaTemplate";
import {formatAccount} from "../../features/ValueFormater";

function Statementofaccounts() {
    const [selectedAccount, setSelectedAccount] = useState('USD');

    function handleAccountChange(event) {
        setSelectedAccount(event.target.value);
    }

    const entityType = sessionStorage.getItem("EntityType");
    return (
        <>
            <HeaderComponent title={entityType==="MERCHANTEMPLOYEE"? "Sales Transactions" : "Statement Of Account"}/>
            <div className="StatementofaccountsPage">
                <div className="container-fluid">
                    <div className="row top_section">
                        <div
                            className="amount">{selectedAccount === "USD" ? formatAccount(sessionStorage.getItem("usdAmount"), 1) : formatAccount(sessionStorage.getItem("lbpAmount"), 2)}</div>
                        <div className="switch">
                            <label className="ddlabel" htmlFor="account">Balance of</label>
                            <select className="ddselect" name="account" id="account" value={selectedAccount}
                                    onChange={handleAccountChange}>
                                <option value="USD">USD Account</option>
                                <option value="LBP">LBP Account</option>
                            </select>
                        </div>
                    </div>
                    <div className="row">
                        {
                            entityType === "LEGALENTITY" ? (
                                <>
                                    {selectedAccount === "USD" && <SoaTemplate currencyId={1}/>}
                                    {selectedAccount === "LBP" && <SoaTemplate currencyId={2}/>}
                                </>
                            ) : (
                                <>
                                    {selectedAccount === "USD" && <MerchantSoaTemplate currencyId={1}/>}
                                    {selectedAccount === "LBP" && <MerchantSoaTemplate currencyId={2}/>}
                                </>
                            )
                        }


                    </div>
                </div>
            </div>
        </>
    );
}

export default Statementofaccounts;